/**
 * Which clicks on a plain anchor the app routes itself (shell.tsx `useInAppLinks`). Same-origin links drawn as plain
 * anchors (the shared Button's `href`, the header logo) would reload the page, and a reload drops this tab's running
 * test timers, which live in memory only. New-tab and download clicks, explicit targets, other origins and clicks
 * already handled (router links prevent the default) keep the browser's behaviour.
 */
export interface LinkClick {
  defaultPrevented: boolean;
  button: number;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
}

export interface LinkTarget {
  /** The anchor's resolved href. */
  href: string;
  target: string;
  download: boolean;
}

/** The path to navigate to in the app, or null to leave the click to the browser. */
export function inAppPath(click: LinkClick, anchor: LinkTarget | null, origin: string): string | null {
  if (!anchor || click.defaultPrevented || click.button !== 0 || click.metaKey || click.ctrlKey || click.shiftKey || click.altKey) return null;
  if ((anchor.target && anchor.target !== "_self") || anchor.download) return null;
  let url: URL;
  try {
    url = new URL(anchor.href, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin) return null;
  return url.pathname + url.search + url.hash;
}
